import React from 'react';
import FollowerAction from '../../actions/follower-action';
import Dispatcher from '../../dispatcher';
import FollowersStore from '../../stores/follower-store';
import Follower from './follower';
import {VstInput, VstButton} from 'vstui';
import { toastUtils } from '../../utils/toast-utils';

var Isvg = require('../../../vendor/react-inlinesvg');

export default class ManageFollowers extends React.Component {
  constructor() {
    super();
    this.state = { failure: false };
    this._followersList = this._list.bind(this, 'followers');
    this._blocksList = this._list.bind(this, 'blocks');

    this.followersLinkRef = React.createRef();
  }

  componentDidMount() {
    Dispatcher.on(Dispatcher.FOLLOWER_STORE_CHANGE, this._onLoad.bind(this))
    Dispatcher.on(Dispatcher.GET_FOLLOWERS_AND_BLOCKS_ERROR, this._onError.bind(this))
    FollowerAction.get();
    Fraction.Helpers.addLoader(".manage-followers");
    Fraction.Helpers.addLoader(".null-screen");
  }

  _onLoad() {
    this.setState(FollowersStore.all());
    Fraction.Helpers.removeLoader(".manage-followers");
    Fraction.Helpers.removeLoader(".null-screen");
  }

  _onError() {
    this.setState({ unavailable: true });
  }

  _copyFollowersLink(e) {
    e.preventDefault();
    var followersLink = document.getElementById('followersLink').value;
    Fraction.Helpers.copyText(followersLink);
    toastUtils.notify({ title: i18n.t("sharing.link-copied"), type: "success" });
  }

  _list(type) {
    return this.state[type].map(follower =>
      <Follower follower={ follower } blocked={ type === 'blocks' } />);
  }

  render() {
    var followerForm = <span />;
    var followersLink = document.location.protocol+"//"+document.location.host+"/home/subscribe/"+encodeURIComponent(Fraction.User.email);
    followerForm = (
      <form className="followers-form" onSubmit={this._copyFollowersLink}>
        <div className="input-container">
          <VstInput id="followersLink" label={i18n.t('sharing.followers-link')} className={"followers-link"} ref={this.followersLinkRef} value={followersLink} type="text" />
        </div>
        <div className="action-options">
          <VstButton id="copyFollowingLink" className="submit copy">
            {i18n.t("base.copy")}
          </VstButton>
        </div>
      </form>);

    var followersList = <span />;
    if ((this.state.followers && this.state.followers.length>0) || (this.state.blocks && this.state.blocks.length>0)){
      followersList =
        <ul className="followers-list noList">
          { this._followersList() }
          { this._blocksList() }
        </ul>;
    } else {
      if (!this.state.unavailable) { // notes server is up!
        followersList =
          <div className="null-screen">
            <Isvg className="watkins" src="/img/sharing_empty_state.svg" />
            <div>{window.toHTML(i18n.t('sharing.no-followers'))}</div>
          </div>;
      } else { // notes server is :(
        followersList =
          <div className="null-screen">
            {Fraction.Brand.Graphics.watkins ?
              <Isvg className="watkins" src="/img/prop_laptop_no.svg" /> :
              <Isvg className="watkins null" src="" />
            }
            <div>{i18n.t('reader.notebook.notes-info-error')}</div>
          </div>;
      }
    }

    return (
      <div className="manage-followers" role="tabpanel">
        <div className="description">
          {window.toHTML(i18n.t('sharing.followers-description'))}
        </div>
        <div className="add-followers">
          {followerForm}
        </div>
        {followersList}
      </div>
    );
  }
}
